import { NovoAIContentType } from 'redux/schemas/models/lecture-page';

// eslint-disable-next-line import/prefer-default-export
export const getContentScopePayloadValue = (type: NovoAIContentType, isFull = false) => {
  switch (type) {
    case NovoAIContentType.SECTION:
      return isFull ? 'lecture_section' : 'section';
    case NovoAIContentType.SUBSECTION:
      return isFull ? 'lecture_subsection' : 'sub_section';
    case NovoAIContentType.LESSON:
      return isFull ? 'lecture_page' : 'page';
    default:
      return '';
  }
};
